import types from 'dashboard/store/mutation-types';

// Copies a task onto every conversation it is linked to in the dashboard's
// conversation list.
//
// The list keys conversations by display_id, while a task payload (REST and
// ActionCable alike) lists each conversation as `{ id, display_id }`, where
// `id` is the internal database id. The two numbers differ per account, and
// one conversation's internal id is often another conversation's display_id,
// so keying by `id` silently puts the card on someone else's conversation.
// Every caller goes through here so that choice is made once.
export const applyTaskToConversations = (store, task) => {
  (task?.conversations || []).forEach(conversation => {
    store.commit(types.UPDATE_CONVERSATION_KANBAN_TASK, {
      task,
      conversationId: conversation.display_id,
    });
  });
};
